
export const ruLanguage=()=>{
    return {
        type:'ru',
    }

};